import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogPage',
})(({ brandColors }) => ({
  gridItem: {
    width: '100%',
  },
  blog: {
    background: brandColors.tintsOffWhite60,
  },
  blogRichTextWrapper: {
    minWidth: 0,
  },
}));

export default useStyles;
